// removed by extract-text-webpack-plugin
module.exports = {"modalBackdrop":"style__modalBackdrop___2A5jV","fade":"style__fade___1ocMI","in":"style__in___2sQnY","preloader":"style__preloader___OiaFX","innerIcon":"style__innerIcon___2v45m","spinner":"style__spinner___12RIQ"};


//////////////////
// WEBPACK FOOTER
// ./components/Spinner/style.scss
// module id = ./components/Spinner/style.scss
// module chunks = 5